import { render, staticRenderFns } from "./PreviewForm13.vue?vue&type=template&id=1aaab110&scoped=true"
import script from "./PreviewForm13.vue?vue&type=script&lang=ts"
export * from "./PreviewForm13.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaab110",
  null
  
)

export default component.exports